import { ComponentPropsWithoutRef } from "react";

type WinnerAvatarProps = {
  name: string;
  winnerColor?: string;
  isSelected?: boolean;
} & ComponentPropsWithoutRef<"div">;

function WinnerAvatar({
  name,
  winnerColor,
  isSelected,
  ...rest
}: WinnerAvatarProps) {
  function prepareStyle() {
    const boxShadow = `0 0 3px 2px ${winnerColor}`;
    const style: React.CSSProperties = {};

    if (rest.onClick === undefined) {
      style.boxShadow = boxShadow;
      return style;
    }

    style.cursor = "pointer";

    if (!isSelected) {
      style.opacity = 0.5;
      return style;
    }

    style.boxShadow = boxShadow;
    return style;
  }

  return (
    <div
      className="us-elections-widget__winner-avatar"
      title={name}
      {...rest}
      style={{
        ...prepareStyle(),
        ...rest.style,
      }}
    ></div>
  );
}

export default WinnerAvatar;
